























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState } from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';
import util from "../../lib/util";
import TagCRUD from  './TagCRUD.vue';



@Component({  
  components: { 
      RotateSquare2,VueElementLoading,TagCRUD
},  
computed: {
...mapState({
 'devices': (state: StoreState) => (state.account as any).devices,
 'Managing_Tag': (state: StoreState) => state.dashboard.Managing_Tag,
 'contact_handler': (state: StoreState) => state.dashboard.contact_handler,
 'Tag_list_': (state: StoreState) =>state.dashboard.Tag_list,
 'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
 'tagstatus': (state: StoreState) => state.dashboard.Tag_status,
  'Tag_status': (state: StoreState) => state.dashboard.Tag_status,
'handletagsidebar' : (state: StoreState) => state.dashboard.handletagsidebar,
'contactsidebar_status': (state: StoreState) => state.dashboard.contactsidebar_status,
})
},






created: function()
{
  //util.handletag();
  var bbb=this.$props.ContacsTags;
  var mnmn=this.$props.contac_tag;
  var nkkn=this.$props.multipleselect;
  
  (this as any).Tag_list_.filter(function (el) {el.select=false })
  this.$data.TAG_List123=(this as any).Tag_list_;
  

  //for multiple contact select , tag enable from Maintagmenu
  if(this.$props.multipleselect!=undefined){
   for(var i=0; i<this.$props.multipleselect.length; i++)
   { 
      this.$data.enable_selctmultag.push(this.$props.multipleselect[i].taglist);
   }

   var enable_selctmultag=this.$data.enable_selctmultag;
    var enableselctmultag_result = enable_selctmultag.shift().filter(function(v) {
    return enable_selctmultag.every(function(a) {
        return a.indexOf(v) !== -1;
    });
    });
    this.$data.TAG_List123.forEach((e1)=>enableselctmultag_result.forEach((e2)=> {
      if(e1._id === e2 && this.$props.multipleselect.length>0){
        e1.select=true;
      }
    } ));
  }
  
  
  // slecet contact tag from table , tag enable form table tag-menu
   else{
    var ContacsTags;
    if(this.$props.ContacsTags==undefined){ ContacsTags=this.$props.contac_tag } //// from newcontact
    if(this.$props.contac_tag==undefined) { ContacsTags=this.$props.ContacsTags.taglist} //From Table contact
    this.$data.TAG_List123.forEach(e1=> {
      if(ContacsTags && ContacsTags.indexOf(e1._id) > -1) e1.select = true;
    } );
   }

 
 // this.gettaglist();
  this.$data.tags = ((this as any).contact_handler.taglist) ? (this as any).contact_handler.taglist : util.handletag();
 }
})

export default class MANAGTAG extends Vue {
   @Prop()
    public multipleselect;

    @Prop()
    public ContacsTags;
   
    @Prop()
    public contac_tag;
    

  data() {
   return {
    is_loading: false,
    selectedDevice: null,
    tab_status:false,
    TAG_List:[ ],
    TAG_List123:[],
    accesstag: true,
    tags: [],
    enable_selctmultag:[]
   }
  }

  createnew_tag(from,editdetail){
    this.$store.commit('MANAGING_TAG','');
    //this.$store.commit("TAB_MANAG",'create');
    this.$store.commit("TAB_MANAG",{evt:'create', from:from,multiselect: this.$props.multipleselect,editdetail:editdetail});
    this.$store.commit('TAB_STATUS' ,true);
  }

 clicktab_event(tg){
  this.$data.TAG_List123=(this as any).Tag_list_;
  var mmm=this.$props.ContacsTags.taglist
  this.$data.TAG_List123.forEach(e1=> {
      if(mmm.indexOf(e1._id) > -1) e1.select = true;
    } );
  }

  

  assign_tag(tag ,evt)
  {
  var contact_info=(this as any).contact_handler;
  var multipleselect_contc=this.$props.multipleselect;
  var selected_contc=(this as any).selectedContact;
  var mmm=(this as any).handletagsidebar;

  /*
  for multiple contacs assign/remove tags  
  */
   if(this.$props.multipleselect!=undefined &&  this.$props.multipleselect.length!=0)
   {
     let contact_arr = [];
     for(let i = 0; i < this.$props.multipleselect.length; i++)
     {
       contact_arr.push(this.$props.multipleselect[i]._id);
       var check = this.$props.multipleselect[i]._id;
      let ele = document.getElementById(check);
      ele.classList.remove('checkboxbg');
           this.$props.multipleselect[i].select = false;
           

      // this.$root.$emit("UnselectAlltablecheckbox", {
      //     selectcont: this.$props.multipleselect[i],
      //     type: false,
      //     });
      
       
     }

      let payload = {payload: {contactid: contact_arr, taglist: [tag._id]}};    
      
     if(evt=="remove")
     {
        this.$data.is_loading=true;
        this.$store.dispatch("deletetag_multicontact",payload).then(r=>{
        //alert("Tag removed")
         this.updateContact(tag._id, 'multiplecontact_removeTag', this.$props.multipleselect, (this as any).handletagsidebar);
         this.$store.commit('MANAGING_TAG','');
        this.$data.is_loading=false;
        this.$emit('refresh_contacttag' ,tag._id,'multiplecontacttag_remove');
       },err=>{
        alert("failed");
      })
      .catch(err=>{
        alert("failed");
      });
     }  

     else{ 
      this.$data.is_loading=true;
      this.$store.dispatch("assigntagmulti",payload).then(r=>{
       // alert("saved")
        this.updateContact(tag._id, 'multiplecontact_assignTag', this.$props.multipleselect, (this as any).handletagsidebar);
        this.$store.commit('MANAGING_TAG','');
        this.$data.is_loading=false;
        this.$emit('refresh_contacttag' ,tag._id,'multiplecontacttag_asssign');
      },err=>{
        alert("failed");
      })
      .catch(err=>{
        alert("failed");
      });
     }
      // contact_arr=[];
      //   this.$props.multipleselect = [];
      //       this.$store.commit(
      //         "CHANGE_SELECTED_CONTACT",
      //         this.$props.multipleselect
      //       );
     


     
  }
  /*
   From single contacs assign tag
  */
  else{ console.log('here',evt,tag);
    this.$data.is_loading=true;
    var check = selected_contc._id;
      let ele = document.getElementById(check);
      ele.classList.remove('checkboxbg');
      let payload = {payload: {contactid:[selected_contc._id], taglist: [tag._id]}};
      this.$store.dispatch("assigntag",payload).then(r=>{
        this.updateContact(tag._id, evt, [selected_contc], (this as any).handletagsidebar);
        this.$data.is_loading=false;
        this.$emit('refresh_contacttag' ,tag._id,evt);
        let oldtag_id = (this as any).selectedContact && (this as any).selectedContact.taglist ? JSON.parse(JSON.stringify((this as any).selectedContact.taglist)) : [];
        if(evt == "remove")
        {
          let oldtagpos = oldtag_id.indexOf(tag._id);
          oldtag_id.splice(oldtagpos, 1);
          let conta = (this as any).selectedContact
          conta.taglist = oldtag_id;
           this.$store.commit("CHANGE_SELECTED_CONTACT", conta);
        } 
        console.log((this as any).selectedContact);
      },err=>{
        this.$data.is_loading=false;
        alert("failed")
      })
      .catch(err=>{
        alert("failed")
      });
   }
  }

  AssignTag_contactdetail(tag,evt) 
  { console.log('hereemiting',tag);
  console.log('emiting event',evt);
   this.$emit('contactdetail_tag',tag,evt)
  }


  gettaglist()
  {
    if(this.$data.accesstag)
    {
      this.$data.accesstag = false;
      this.$data.loading_tag=true;
      this.$data.TAG_List = util.handletag();
    }
  }

  updateContact(tagid = "", type = "assign", contact, flag) //remove
  {
    let count = contact.length;
    let tags = util.handletag();
    let tindex = tags.map(e=>e._id).indexOf(tagid);
    debugger
    if(type != "multiplecontact_assignTag" && type!="multiplecontact_removeTag")
    { 
      if( type == "assign"){ 
         tags[tindex].contact_count += count;
        this.$data.TAG_List123.forEach(e1=> {
          if(tagid==e1._id) e1.select = true;
      } );
      }
       
      else{
         tags[tindex].contact_count -= count;
        this.$data.TAG_List123.forEach(e1=> {
          if(tagid==e1._id) e1.select = false;
      } );
      }
     
      util.handletag(tags, 'set');
      this.$store.commit('HANDLE_TAG_SIDEBAR' ,!flag);
      console.log((this as any).selectedContact);
    }
    else
    {
      if(type == "multiplecontact_assignTag" )
      {
         this.$data.TAG_List123.forEach(e1=> {
        if(tagid==e1._id) {e1.select = true; }
      } );
        let temp_count = tags[tindex].contact_count ? tags[tindex].contact_count : 0;
        for(let i = 0; i < count; i++){
        if(contact[i].taglist.indexOf(tagid) == -1) temp_count += 1;
        tags[tindex].contact_count = temp_count;
        util.handletag(tags, 'set');
        this.$store.commit('HANDLE_TAG_SIDEBAR' ,!flag);
        debugger
        
        //temp_count = 0;
        }
      }
      if(type=="multiplecontact_removeTag")
      {
         this.$data.TAG_List123.forEach(e1=> {
        if(tagid==e1._id) {e1.select = false; }
      } );
        let temp_count = tags[tindex].contact_count ? tags[tindex].contact_count : 0;
        for(let i = 0; i < count; i++)
        {
        if(contact[i].taglist.indexOf(tagid) != -1) temp_count -= 1;
        tags[tindex].contact_count = temp_count;
        util.handletag(tags, 'set');
        this.$store.commit('HANDLE_TAG_SIDEBAR' ,!flag);
        //temp_count = 0;
          }
      }
    }
    
  }


   
}
